export const videoScreenCords = [
    {
        x: 0,
        y: 0,
    },
    {
        x: 0,
        y: 2,
    },
    {
        x: 2,
        y: 2,
    },
    {
        x: 2,
        y: 0,
    },
    {
        x: 4,
        y: 0,
    },
    {
        x: 4,
        y: 2,
    },
];

export const videoTransitionCords = [
    null,
    {
        x: 0,
        y: 1,
    },
    {
        x: 1,
        y: 2,
    },
    {
        x: 2,
        y: 1,
    },
    {
        x: 3,
        y: 0,
    },
    {
        x: 4,
        y: 1,
    },
];

export const scorePositions = [
    [
        [0, 0],
        [0, 1],
        [1, 0],
        [0, -1],
        [1, 0],
        [0, 1],
    ],
    [
        [0, -1],
        [0, 0],
        [1, 0],
        [0, -1],
        [1, 0],
        [0, 1],
    ],
    [
        [0, -1],
        [-1, 0],
        [0, 0],
        [0, -1],
        [1, 0],
        [0, 1],
    ],
    [
        [0, -1],
        [-1, 0],
        [0, 1],
        [0, 0],
        [1, 0],
        [0, 1],
    ],
    [
        [0, -1],
        [-1, 0],
        [0, 1],
        [-1, 0],
        [0, 0],
        [0, 1],
    ],
    [
        [0, -1],
        [-1, 0],
        [0, 1],
        [-1, 0],
        [0, -1],
        [0, 0],
    ],
];
